(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4754],{

/***/ 64754:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(64836);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(10434));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(70215));

var _react = _interopRequireDefault(__webpack_require__(67294));

const IconStep4 = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.031.072C5.441.072.098 5.414.098 12.005c0 6.59 5.343 11.933 11.933 11.933s11.934-5.342 11.934-11.933c0-6.59-5.343-11.933-11.934-11.933zm0 1.5c5.762 0 10.434 4.67 10.434 10.433 0 5.762-4.672 10.433-10.434 10.433S1.598 17.768 1.598 12.005c0-5.762 4.671-10.433 10.433-10.433z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.843 14.337H8.871a.61.61 0 01-.572-.818l2.465-6.76a.8.8 0 111.504.55l-2.02 5.508h2.595l.065-2.265a.811.811 0 011.622.023v2.242h.71a.76.76 0 010 1.52h-.71v1.82a.843.843 0 01-1.687 0v-1.82z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconStep4, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports["default"] = _default;

/***/ }),

/***/ 10434:
/***/ (function(module) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 70215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(7071);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 7071:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

}]);